import { Languages } from 'lucide-react';
import { LANGUAGES, useI18n } from '@/lib/i18n';
import { Button } from '@/components/ui/Button';
import { Menu } from '@/components/ui/Menu';

/** EN / HI switcher. The choice is persisted and sets <html lang>. */
export function LanguageSwitcher({ compact }: { compact?: boolean }) {
  const { lang, setLang, t } = useI18n();
  const current = LANGUAGES.find((l) => l.code === lang);
  return (
    <Menu
      label={t('shell.language')}
      items={LANGUAGES.map((l) => ({ id: l.code, label: l.native, checked: lang === l.code, onSelect: () => setLang(l.code) }))}
      trigger={
        <Button variant="ghost" size="sm" aria-label={`${t('shell.language')}: ${current?.label}`} leftIcon={<Languages className="h-4 w-4" aria-hidden="true" />}>
          {compact ? lang.toUpperCase() : current?.native}
        </Button>
      }
    />
  );
}
